module.exports = __webpack_public_path__ + "static/media/2013_Population_totalRate.ffb80d28.png";